import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import componentErrorBoundary from "./enhancers/componentErrorBoundary";

// eslint-disable-line @typescript-eslint/no-explicit-any

// Original idea: https://code-maven.com/create-and-download-csv-with-javascript
// CSV RFC https://tools.ietf.org/html/rfc4180

var normalizeEntry = function normalizeEntry(text) {
  if (text === null) return 'null';
  if (text === undefined) return '';
  if (text === false) return 'false';
  if (text === true) return 'true';
  if (typeof text === 'number') {
    return String(text);
  }
  if (typeof text !== 'string') {
    console.warn('text is not a string', text);
    return text;
  }
  if (text.match(/[,\n\r]/)) {
    var aux = text.replace(/"/g, '""');
    return "\"".concat(aux, "\"");
  }
  return text;
};
var selectData = function selectData(obj, selector, column) {
  if (!selector) return null;
  if (typeof selector === 'function') return selector(obj, column);
  if (typeof selector === 'string') return obj[selector];
  throw new TypeError('selectData: Selector must be a string or a function');
};
var toCsvFile = function toCsvFile(data) {
  try {
    return "data:text/csv;base64,".concat(btoa(data));
  } catch (ex) {
    return '';
  }
};
var CsvDownload = function CsvDownload(_ref) {
  var children = _ref.children,
    className = _ref.className,
    columns = _ref.columns,
    data = _ref.data,
    fileName = _ref.fileName,
    id = _ref.id;
  var href = useMemo(function () {
    var lines = [columns.map(function (e) {
      return normalizeEntry(e.name);
    }).join(',')];
    lines = lines.concat(data.map(function (line) {
      return columns.map(function (e) {
        return normalizeEntry(selectData(line, e.selector, e));
      }).join(',');
    }));
    var allLines = lines.join('\n');
    return toCsvFile(allLines);
  }, [data, columns]);
  return /*#__PURE__*/React.createElement("a", {
    className: className,
    "data-testid": "csv-download-link",
    disabled: !href,
    download: fileName,
    href: href,
    id: id,
    target: "_blank",
    type: "text/csv",
    rel: "noreferrer"
  }, children);
};
CsvDownload.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    selector: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
  })).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired
};
CsvDownload.defaultProps = {
  children: 'download',
  fileName: 'file.csv'
};
export default componentErrorBoundary(CsvDownload);